import React from 'react';

export type MessageDialogType = 'info' | 'success' | 'warning' | 'error' | 'confirm';

export interface MessageDialogProps {
  isOpen: boolean;
  type: MessageDialogType;
  title: string;
  message: string | React.ReactNode;
  onClose: () => void;
  onConfirm?: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmClassName?: string;
}

const ICON_MAP: Record<MessageDialogType, { icon: string; color: string }> = {
  info: { icon: 'info', color: 'var(--color-primary)' },
  success: { icon: 'check_circle', color: 'var(--color-success)' },
  warning: { icon: 'warning', color: 'var(--color-warning)' },
  error: { icon: 'error', color: 'var(--color-danger)' },
  confirm: { icon: 'help', color: 'var(--color-primary)' },
};

const MessageDialog: React.FC<MessageDialogProps> = ({
  isOpen,
  type,
  title,
  message,
  onClose,
  onConfirm,
  confirmLabel,
  cancelLabel = 'キャンセル',
  confirmClassName,
}) => {
  if (!isOpen) return null;

  const { icon, color } = ICON_MAP[type];
  const isConfirmType = type === 'confirm' || !!onConfirm;

  return (
    <div className="modal-overlay">
      <div className="modal" role="dialog">
        <h2 className="modal__title" style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}>
          <span className="material-symbols-outlined" style={{ color, fontSize: '24px' }}>{icon}</span>
          {title}
        </h2>
        <div className="text-muted mb-6" style={{ fontSize: 'var(--text-base)', whiteSpace: 'pre-line' }}>
          {message}
        </div>
        <div className="modal__actions">
          {isConfirmType ? (
            <>
              <button className="btn btn--secondary" onClick={onClose}>
                {cancelLabel}
              </button>
              <button
                className={confirmClassName || 'btn btn--primary'}
                onClick={() => {
                  onConfirm?.();
                }}
              >
                {confirmLabel || 'OK'}
              </button>
            </>
          ) : (
            <button className="btn btn--primary" onClick={onClose}>
              OK
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default MessageDialog;
